// extracted by mini-css-extract-plugin
export var accordionControl = "referencedSection-module--accordionControl--6876e";
export var carouselContainer = "referencedSection-module--carouselContainer--f9fc7";
export var chevron = "referencedSection-module--chevron--40b1e";
export var column = "referencedSection-module--column--76538";
export var commitmentCard = "referencedSection-module--commitmentCard--d06d6";
export var commitmentCardLeftSection = "referencedSection-module--commitmentCardLeftSection--18a78";
export var commitmentCardRightSection = "referencedSection-module--commitmentCardRightSection--d5700";
export var control = "referencedSection-module--control--10e0b";
export var controls = "referencedSection-module--controls--a2f1b";
export var customTestiominalFooter = "referencedSection-module--customTestiominalFooter--1697e";
export var divider = "referencedSection-module--divider--98b5f";
export var dividerContainer = "referencedSection-module--dividerContainer--4fe8b";
export var externalLink = "referencedSection-module--externalLink--afd59";
export var grid = "referencedSection-module--grid--8e21d";
export var innerContainer = "referencedSection-module--innerContainer--2d7a1";
export var internalLink = "referencedSection-module--internalLink--d822f";
export var isDarkBanner = "referencedSection-module--isDarkBanner--5572c";
export var item = "referencedSection-module--item--e41e1";
export var label = "referencedSection-module--label--bda1b";
export var philCarouselViewport = "referencedSection-module--phil-Carousel-viewport--f425b";
export var recentClientNewsHeader = "referencedSection-module--recentClientNewsHeader--518e8";
export var root = "referencedSection-module--root--09ebf";
export var sectionImage = "referencedSection-module--sectionImage--88770";
export var subHeading = "referencedSection-module--subHeading--4fa0f";
export var title = "referencedSection-module--title--9edd2";